import { useState } from "react";
import { DModalState } from "../../compiler/global.default";
import { IModalState } from "../../compiler/global.interface";
import { TStatus } from "../../compiler/global.type";

export const blurActiveElementBeforeOpeningModal = (openState: boolean) => {
  if (!openState || typeof document === "undefined") return;
  const activeElement = document.activeElement;
  if (activeElement instanceof HTMLElement) {
    activeElement.blur();
  }
};

const useModalState = (
  initialState?
): [
  IModalState,
  any,
  (
    openState: boolean,
    statusState?: TStatus,
    titleText?: string | null,
    detailText?: string | null,
    storeValue?: object
  ) => void,
] => {
  const [modalState, setModalState] = useState<IModalState>({ ...DModalState, ...initialState });

  const toggleModalState = (
    openState: boolean = !modalState.open,
    statusState?: TStatus,
    titleText?: string | null,
    detailText?: string | null,
    storeValue?: object
  ): void => {
    blurActiveElementBeforeOpeningModal(openState);
    let nextValue = {
      ...modalState,
      open: openState,
      ...(titleText != null && { title: titleText }),
      detail: detailText || "",
      status: statusState || ("" as ""),
      ...(storeValue != null && { store: { ...modalState.store, ...storeValue } }),
    };
    setModalState(() => nextValue);
  };

  return [modalState, setModalState, toggleModalState];
};

export default useModalState;
